<template>
    <section class="home-container">
        <MasterPage title="营养素管理">
            <div slot="title-icon">
                <Icon type="ios-medkit" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="8">
                        <FormItem label="营养素名称：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="处方营养素：">
                            <Select v-model="select.isOTC" clearable placeholder="请选择">
                                <Option value="true">是处方营养素</Option>
                                <Option value="false" >非处方营养素</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="营养素状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addItem_modal">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增营养素" @on-cancel="cancelItem">
            <Form :label-width="120">
                <FormItem label="营养素名称：">
                    <Input v-model="itemAdd.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="营养素英文名称：">
                    <Input v-model="itemAdd.nameEn" placeholder="请输入" />
                </FormItem>
                <FormItem label="处方营养素：">
                    <i-switch v-model="itemAdd.isOTC" size="large">
                        <span slot="open">是</span>
                        <span slot="close">非</span>
                    </i-switch>
                </FormItem>
                <FormItem label="营养素描述：">
                    <Input v-model="itemAdd.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入" />
                </FormItem>
                <FormItem label="营养素英文描述：">
                    <Input v-model="itemAdd.descriptionEn" type="textarea" :autosize="{minRows: 3,maxRows: 6}" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改营养素" @on-cancel="cancelItem">
            <Form :label-width="120">
                <FormItem label="营养素名称：">
                    <Input v-model="updateInfoItem.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="营养素英文名称：">
                    <Input v-model="updateInfoItem.nameEn" placeholder="请输入" />
                </FormItem>
                <FormItem label="处方营养素：">
                    <i-switch v-model="updateInfoItem.isOTC" size="large">
                        <span slot="open">是</span>
                        <span slot="close">非</span>
                    </i-switch>
                </FormItem>
                <FormItem label="营养素描述：">
                    <Input v-model="updateInfoItem.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入" />
                </FormItem>
                <FormItem label="营养素英文描述：">
                    <Input v-model="updateInfoItem.descriptionEn" type="textarea" :autosize="{minRows: 3,maxRows: 6}" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="营养素详情" width="750">
            <Form :label-width="120">
                <FormItem  label="营养素名称：">
                    {{infoItem.name}}
                </FormItem>
                <FormItem label="营养素英文名称：">
                    {{infoItem.nameEn}}
                </FormItem>
                <FormItem label="处方药：">
                    {{infoItem.isOTC?'是处方药':'非处方药'}}
                </FormItem>
                <FormItem label="营养素描述：">
                    <div style="white-space: pre-wrap">{{infoItem.description}}</div>
                </FormItem>
                <FormItem label="营养素英文描述：">
                    <div style="white-space: pre-wrap">{{infoItem.descriptionEn}}</div>
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '名称',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '英称',
                        key: 'nameEn',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '是否为处方营养素',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].isOTC){
                                return h('span', '是')
                            }else{
                                return h('span', '非')
                            }
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    name:'',
                    isOTC:'',
                    isDeleted:'false',
                },
                itemAdd:{
                    name:'',
                    nameEn:'',
                    isOTC:true,
                    description:'',
                    descriptionEn:'',
                },
                updateInfoItem:"",
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('nutrient/list',{
                    name:this.select.name,
                    isOTC:this.select.isOTC == undefined ? "" : this.select.isOTC,
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'营养素列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem_modal(){
                this.addModel=true
                this.itemAdd = {name:'',isOTC:true,usage:'',effect:'',indication:'',}
            },
            addItem(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入营养素名称');
                }
                if (this.itemAdd.nameEn.length <= 0){
                    return this.$Message.warning('请输入营养素英文名称');
                }
                if (this.itemAdd.description.length <= 0){
                    return this.$Message.warning('请输入营养素描述');
                }
                if (this.itemAdd.descriptionEn.length <= 0){
                    return this.$Message.warning('请输入营养素英文描述');
                }
                this.addLoading = true
                this.$http.post('nutrient/add',{
                    name:this.itemAdd.name,
                    nameEn:this.itemAdd.nameEn,
                    isOTC:this.itemAdd.isOTC,
                    description:this.itemAdd.description,
                    descriptionEn:this.itemAdd.descriptionEn,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养素新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养素新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入营养素名称');
                }
                if (this.updateInfoItem.nameEn.length <= 0){
                    return this.$Message.warning('请输入营养素英文名称');
                }
                if (this.updateInfoItem.description.length <= 0){
                    return this.$Message.warning('请输入营养素描述');
                }
                if (this.updateInfoItem.descriptionEn.length <= 0){
                    return this.$Message.warning('请输入营养素英文描述');
                }
                this.updateLoading = true
                this.$http.post('nutrient/update',{
                    id:this.updateInfoItem.id,
                    name:this.updateInfoItem.name,
                    nameEn:this.updateInfoItem.nameEn,
                    isOTC:this.updateInfoItem.isOTC,
                    description:this.updateInfoItem.description,
                    descriptionEn:this.updateInfoItem.descriptionEn,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养素修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养素修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd = {
                    name:'',
                    nameEn:'',
                    isOTC:true,
                    description:'',
                    descriptionEn:'',
                }
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用营养素“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('nutrient/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养素启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养素启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用营养素“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('nutrient/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养素禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'营养素禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


